import type { ComponentWithValues } from 'common/stack/ComponentWithValuesDocuments';
import { ComponentHost } from './ComponentHost';

interface ComponentHostsProps {
  component: ComponentWithValues | null | undefined;
}

export const ComponentHosts = ({ component, ...other }: ComponentHostsProps) => {
  if (!component) return null;
  if (!component?.hosts?.length) return null;

  return (
    <section {...other}>
      {component?.hosts?.map((host) => <ComponentHost stackComponentID={component.stackComponentID} host={host} />)}
    </section>
  );
};
